import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { NewAuditLogRecord } from './AuditLogPanel.types';
import AuditLogCellValue from './AuditLogCellValue';

interface Props {
	record: NewAuditLogRecord & { type: 'created' | 'deleted' };
	hiddenFields: string[];
}

const useStyles = makeStyles(() => ({
	table: {
		tableLayout: 'fixed',
		'& tr:last-child td': { borderBottom: 'none' },
	},
	cell: {
		padding: '5px 8px',
		borderColor: 'oklch(93% 0.005 85)',
	},
	keyCell: {
		width: '50%',
		fontFamily: '"Roboto Mono", "Courier New", monospace',
		fontSize: '1.1rem',
		color: 'oklch(55% 0.008 55)',
	},
	valueCell: {
		textAlign: 'right',
		fontSize: '1.3rem',
		color: 'oklch(35% 0.010 55)',
	},
	rowCreated: {
		backgroundColor: 'oklch(97% 0.022 145)',
	},
	rowDeleted: {
		backgroundColor: 'oklch(97.5% 0.016 22)',
	},
}));

function capitalize(str: string): string {
	return str.charAt(0).toUpperCase() + str.slice(1);
}

function AuditLogSnapshotView({ record, hiddenFields }: Props) {
	const classes = useStyles();
	const fields = Object.entries(record.snapshot).filter(([key]) => !hiddenFields.includes(key));
	const rowClass = record.type === 'created' ? classes.rowCreated : classes.rowDeleted;

	if (fields.length === 0) return null;

	return (
		<Table className={classes.table} size="small">
			<TableBody>
				{fields.map(([key, value]) => (
					<TableRow key={key} className={rowClass}>
						<TableCell className={`${classes.cell} ${classes.keyCell}`}>
							{capitalize(key)}
						</TableCell>
						<TableCell className={`${classes.cell} ${classes.valueCell}`}>
							<AuditLogCellValue value={value} />
						</TableCell>
					</TableRow>
				))}
			</TableBody>
		</Table>
	);
}

export default AuditLogSnapshotView;
